import React, { useContext } from "react";
import { observer } from "mobx-react";
import { useFormik } from "formik";
import { DesktopClient } from "../../../../api/firebase/types/device.types";
import DeviceNameInput from "./fields/DeviceNameInput";
import DeviceMailInput from "./fields/DeviceMailInput";
import { mailRegEx } from "../../../../api/validation";
import { createDesktopUser } from "../../../../api/firebase/functionCallables/desktopUserCallables";
import ToastContext from "../../../../components/toast/ToastContext";
import { DeviceToasts } from "../../../../toastMessages/deviceToastMessages";

export type DesktopClientFormData = Pick<DesktopClient, "name" | "email">;

type AddDesktopClientFormProps = {
  onSave: (deviceData: DesktopClientFormData) => void;
  showLoader: (loading: boolean) => void;
};
const AddDesktopClientForm: React.FC<AddDesktopClientFormProps> = (props) => {
  const showToast = useContext(ToastContext);
  const formik = useFormik<DesktopClientFormData>({
    initialValues: {
      name: "",
      email: "",
    },
    validate: (data) => {
      let errors: Partial<DesktopClientFormData> = {};

      if (!data.name) {
        errors.name = "Bitte geben Sie der Meldeinstanz eine Bezeichnung";
      }

      if (!data.email) {
        errors.email = "Bitte weisen Sie der Meldeinstanz eine Email zu";
      } else if (!mailRegEx.test(data.email)) {
        errors.email = "Ungültige Email Adresse";
      }
      return errors;
    },
    onSubmit: async (data) => {
      props.showLoader(true);
      const status = await createDesktopUser(data.email);
      const { desktopUserAlreadyExistsError, desktopUserCreationError } =
        DeviceToasts;
      switch (status) {
        case "created":
          props.onSave(data);
          break;
        case "auth/email-already-exists":
          showToast(desktopUserAlreadyExistsError);
          props.showLoader(false);
          break;
        default:
          showToast(desktopUserCreationError);
          props.showLoader(false);
      }
    },
  });

  const isFormFieldValid = (name: keyof DesktopClientFormData) =>
    !!(formik.touched[name] && formik.errors[name]);

  const getFormErrorMessage = (name: keyof DesktopClientFormData) =>
    isFormFieldValid(name) ? (
      <small className="p-error p-d-block form-error">
        {formik.errors[name]}
      </small>
    ) : undefined;

  return (
    <form
      className="p-formgrid p-grid"
      id="device-creation-modal"
      onSubmit={formik.handleSubmit}
    >
      <DeviceNameInput
        name={formik.values.name}
        onNameChange={formik.handleChange}
        errorMessage={getFormErrorMessage("name")}
      />
      <DeviceMailInput
        email={formik.values.email}
        onEmailChange={formik.handleChange}
        errorMessage={getFormErrorMessage("email")}
      />
    </form>
  );
};

export default observer(AddDesktopClientForm);
